import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { DEFAULT_WIFI_CONFIG } from '../../../../constants/readerDefault';

const WifiConfigSection = ({ onSendWifi, sending, disabled }) => {
  const [isActive, setIsActive] = useState(false);
  const [ssid, setSsid] = useState(DEFAULT_WIFI_CONFIG.ssid);

  const handleSsidChange = (e) => {
    const val = e.target.value;
    // Strip spaces (including tabs, newlines, etc.)
    const cleanVal = val.replace(/\s/g, '');
    setSsid(cleanVal);
  };

  const handleSsidKeyDown = (e) => {
    if (e.key === ' ') {
      e.preventDefault();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!ssid || sending) return;
    onSendWifi(ssid);
  };

  return (
    <section className="config-wifi-section" aria-labelledby="wifi-section-title">
      <header className="config-wifi-header">
        <h6 id="wifi-section-title" className="text-muted small text-uppercase mt-0 mb-2 font-weight-bold config-preview-section-title">
          <strong>Configuración Wi-Fi</strong>
        </h6>
      </header>

      <div className="config-wifi-form">
        <div className="config-wifi-row">
          <span id="wifi-toggle-label" className="config-wifi-label">
            Habilitar envío de Wi-Fi:
          </span>
          <label className="custom-toggle-switch mb-0">
            <input
              id="wifi-toggle-switch"
              type="checkbox"
              checked={isActive}
              onChange={(e) => setIsActive(e.target.checked)}
              disabled={disabled || sending}
              aria-labelledby="wifi-toggle-label"
              aria-controls="wifi-config-inputs-container"
              aria-expanded={isActive}
            />
            <span className="toggle-slider" />
          </label>
        </div>

        {isActive && (
          <div id="wifi-config-inputs-container" className="wifi-config-inputs">
            <div className="config-wifi-row">
              <label htmlFor="wifi-ssid-input" className="config-wifi-label">
                SSID (Red):
              </label>
              <input
                id="wifi-ssid-input"
                type="text"
                value={ssid}
                onChange={handleSsidChange}
                onKeyDown={handleSsidKeyDown}
                className="config-wifi-input"
                placeholder="Nombre de la red"
                required
                maxLength={32}
                disabled={disabled || sending}
              />
            </div>

            <div className="text-center py-2 mt-3">
              <button
                type="button"
                className="btn btn-admin-button active btn-send-config btn-send-wifi"
                disabled={disabled || sending || !ssid.trim()}
                onClick={handleSubmit}
              >
                {sending ? 'Enviando...' : 'Configurar Wi-Fi'}
              </button>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

WifiConfigSection.propTypes = {
  onSendWifi: PropTypes.func.isRequired,
  sending: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
};

export default WifiConfigSection;
